<template>
  <div class="hello"></div>
</template>

<script>
import { getWechatArgs } from "../api/user.js";
export default {
  name: "WxShare",
  data() {
    return { currentUser: "" };
  },
  created() {
    let url = window.location.href;
    getWechatArgs({ url: url }).then(res => {
      this.wxInit(res);
    });
  },
  methods: {
    wxInit: function(sd) {
      let links = window.location.href;
      let title = "高校开学防疫攻略";
      let desc = " ";
      let imgUrl = "https://2d.hep.com.cn/img/icon-108.png";
      this.$wechat.config({
        debug: false,
        appId: sd.appId,
        timestamp: sd.timestamp,
        nonceStr: sd.nonceStr,
        signature: sd.signature,
        jsApiList: [
          "updateAppMessageShareData",
          "updateTimelineShareData",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "chooseImage",
          "previewImage",
          "uploadImage",
          "downloadImage",
          "chooseWXPay",
          "getLocalImgData",
          "openLocation",
          "getLocation"
        ]
      });
      var _this = this;
      this.$wechat.ready(function() {
        _this.$wechat.onMenuShareTimeline({
          title: title,
          link: links,
          imgUrl: imgUrl,
          success: function() {},
          cancel: function() {
            alert("亲爱的，咋取消了呢，勇敢一点分享吧!");
          }
        });
        _this.$wechat.onMenuShareAppMessage({
          title: title,
          desc: desc,
          link: links,
          imgUrl: imgUrl,
          success: function() {},
          cancel: function() {
            alert("亲爱的，咋取消了呢，勇敢一点分享吧!");
          }
        });
        _this.$wechat.onMenuShareQQ({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: links, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: function() {},
          cancel: function() {
            alert("亲爱的，咋取消了呢，勇敢一点分享吧!");
          }
        });
        _this.$wechat.onMenuShareWeibo({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: links, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: function() {},
          cancel: function() {
            alert("亲爱的，咋取消了呢，勇敢一点分享吧!");
          }
        });
      });
      this.$wechat.error(function(res) {
        console.log("wechat error", res);
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    }
  },
  watch: {
    $route: "wxInit"
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
